import { API } from "../config/api"
import { DataService } from "../config/dataService/dataService"

class TopicsService {

  static async getTopics({ page = 1, search = '' }) {
    const params = {
      page,
      search
    }
    const { data } = await DataService.get(API.topics.root, params)
    return {
      topics: data.topics,
      total: data.total,
      pageSize: data.pageSize
    };
  }

  static async getAssignedTopics() {
    const { data } = await DataService.get(`${API.topics.root}${API.topics.assigned}`)
    return {
      topics: data.topics,
    }
  }

  static async getTopicsById(topicId) {
    const { data } = await DataService.get(`${API.topics.root}/${topicId}`)
    return {
      topic: data.topic,
    };
  }

  static async createTopics(newData) {
    const topicsData = {
      name: newData.name,
      idColor: newData.idColor,
      topicInfo: {
        serviceTypes: newData.serviceTypes,
      },
      filters: {
        specialities: newData.specialities
      }
    };
    const { data } = await DataService.post(API.topics.root, topicsData)
    return {
      topicss: data.topics,
    };
  }

  static async updateTopics(id, newData) {
    const topicsData = {
      name: newData.name,
      idColor: newData.idColor,
      topicInfo: {
        serviceTypes: newData.serviceTypes,
      },
      filters: {
        specialities: newData.specialities
      }
    };
    const { data } = await DataService.patch(`${API.topics.root}/${id}`, topicsData)
    return {
      topics: data.topics,
    }
  }

  static async deleteTopics(id) {
    const { data } = await DataService.delete(`${API.topics.root}/${id}`)
    return {
      topics: data.topics,
    };
  }

}

export { TopicsService }